import {observer} from 'mobx-react';
import {AdvancedMarker, APIProvider, Map, Pin} from '@vis.gl/react-google-maps';
import AddressForm from 'shared/components/google_location_picker/components/AddressForm';
import RadiusCircle from 'shared/components/google_location_picker/components/RadiusCircle';
import {ActionLink} from 'shared/components/links';
import {FormattedMessage} from 'react-intl';
import GoogleMapsApi from '../GoogleMapsApi';
import {useState} from 'react';
import FormError from 'shared/components/FormError';

const DEFAULT_CENTER = {lat: 43.6532, lng: -79.3832};
const DEFAULT_ZOOM = 12;
const RADIUS_SIZE = 250;

const GoogleLocationPicker = observer(({value: coords, onChange, width = '100%', height = '300px'}) => {
  const [error, setError] = useState();

  function clearError() {
    setError();
  }

  async function onMapClick(e) {
    clearError();

    const latLng = e.detail.latLng;

    if (!latLng) return;

    const {results, error} = await GoogleMapsApi.geocode({lat: latLng.lat, lng: latLng.lng});

    if (error) {
      setError(error);
      return;
    }

    const {formatted_address} = results[0];

    onChange({...latLng, address: formatted_address});
  }

  return (
    <APIProvider apiKey={GoogleMapsApi.API_KEY}>
      <AddressForm
        onChange={onChange}
        onError={setError}
        clearError={clearError}
      />
      {error && <FormError className='mb1' message={error}/>}
      <Map
        mapId='google-location-picker'
        onClick={onMapClick}
        defaultCenter={coords ?? DEFAULT_CENTER}
        defaultZoom={coords ? 15 : DEFAULT_ZOOM}
        style={{width, height}}
        streetViewControl={false}
        fullscreenControl={false}
        mapTypeControl={false}
      >
        <RadiusCircle coords={coords} size={RADIUS_SIZE} />
        {coords && (
          <AdvancedMarker position={coords}>
            <Pin />
          </AdvancedMarker>
        )}
      </Map>
      <div className='mt2'>
        <ActionLink onClick={() => onChange(null)}>
          <FormattedMessage id='components.google_location_picker.Clear location'/>
        </ActionLink>
      </div>
    </APIProvider>
  );
});

export default GoogleLocationPicker;
